document.addEventListener("DOMContentLoaded", function () {
    let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
    wishlist = wishlist.filter(item => item !== ""); // Empty items remove karein
    localStorage.setItem("wishlist", JSON.stringify(wishlist)); // Update LocalStorage

    console.log("Wishlist Loaded:", wishlist); // Debugging

    function updateWishlistIcons() {
        document.querySelectorAll(".wishlist-btn").forEach((btn) => {
            const productHandle = btn.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
                btn.classList.add("active"); // Full black fill
            } else {
                btn.classList.remove("active");
            }
        });
    }

    function showPopup(message) {
        let popup = document.createElement("div");
        popup.className = "wishlist-popup";
        popup.innerText = message;
        document.body.appendChild(popup);

        setTimeout(() => {
            popup.classList.add("hide");
            setTimeout(() => popup.remove(), 500);
        }, 2000);
    }

    document.querySelectorAll(".wishlist-btn").forEach((btn) => {
        btn.addEventListener("click", function () {
            const productHandle = this.dataset.productHandle;
            console.log("Wishlist Button Clicked:", productHandle);
            
            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter(item => item !== productHandle);
                showPopup("Removed from Wishlist");
                console.log("Removed from Wishlist:", wishlist);
            } else {
                wishlist.push(productHandle);
                showPopup("Added to Wishlist");
                console.log("Added to Wishlist:", wishlist);
            }

            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            updateWishlistIcons();
        });
    });

    updateWishlistIcons();
});
